import React, { useState, useEffect } from "react";
import { Table, Image, Button } from "react-bootstrap";
//import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import BasicPagination from "../../../../Pagination/Pagination";
import isEmpty from "../../../../../store/validation/is-Empty";

const UserFavoritesRestaurant = (props) => {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [sort, setSort] = useState("");

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);

  useEffect(() => {
    if (!isEmpty(props.sortValue)) {
      setSort(props.sortValue);
    }
  }, [props.sortValue]);

  let filterRestaurant = props.groupByData.filter((restaurant) => {
    return (
      restaurant &&
      restaurant &&
      restaurant.restaurant_name &&
      restaurant.restaurant_name
        .toLowerCase()
        .includes(props.search.toLowerCase())
    );
  });
  if (sort === "A-Z") {
    filterRestaurant = filterRestaurant.sort((a, b) => {
      if (a?.restaurant_name?.toLowerCase() < b?.restaurant_name?.toLowerCase())
        return -1;
      if (a?.restaurant_name?.toLowerCase() > b?.restaurant_name?.toLowerCase())
        return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    filterRestaurant = filterRestaurant.sort((a, b) => {
      if (a?.restaurant_name?.toLowerCase() < b?.restaurant_name?.toLowerCase())
        return 1;
      if (a?.restaurant_name?.toLowerCase() > b?.restaurant_name?.toLowerCase())
        return -1;
      return 0;
    });
  }

  const onClickViewSetData = (data) => (e) => {
    history.push({
      pathname: "/superadminuserfavorite/group/restaurant",
      state: { data: data },
    });
  };

  return (
    <React.Fragment>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "35%" }}>Restaurant / Location</th>
              <th style={{ width: "20%" }}>Total Favourites</th>
              <th style={{ width: "15%" }}>Viewed</th>
              <th style={{ width: "15%" }}>Used</th>
              <th style={{ width: "15%" }}>View Fav Details</th>
            </tr>
          </thead>
          {filterRestaurant.slice(start, end).map((restaurant, index) => (
            <tbody key={index}>
              <tr className="enUserFavoritesTableBody">
                <td style={{ width: "35%" }}>
                  <div className="d-flex align-items-center">
                    <div className="restaurant_image_box">
                      <Image
                        //src={require("../../../../../assets/images/superadmin/streetmeat.png")}
                        src={restaurant && restaurant.logo_url}
                        alt="Restaurant pic"
                        title="Restaurant Pic"
                        fluid
                      />
                    </div>
                    <div className="pl-2">
                      <div className="f14-500">
                        {restaurant && restaurant && restaurant.restaurant_name}
                      </div>
                      <div className="f12-400">
                        {restaurant && restaurant.city}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f16-500">{restaurant.totalFavourites}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f16-500">Yes</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f16-500">No</div>
                </td>
                <td style={{ width: "15%" }}>
                  {/* <NavLink
                    to={`/superadminuserfavorite/group/restaurant/${index}`}
                    className="enIconBtn"
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </NavLink> */}
                  <Button
                    className="enIconBtn"
                    onClick={onClickViewSetData(restaurant)}
                    style={{ background: "none" }}
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                </td>
              </tr>
            </tbody>
          ))}
        </Table>
      </div>
      {filterRestaurant.length !== 0 ? (
        <BasicPagination
          totalRecords={filterRestaurant.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
    </React.Fragment>
  );
};

export default UserFavoritesRestaurant;
